import async from "async";
import * as AdminService from '../services/adminService';
import {receiveSurveys} from "../actions/panelAction";

export const PanelSurveyPageServices = (dispatch,params) => {
    return new Promise((resolve, failure) => {
        async.series([
            (cb) => {
                AdminService.getSurveys(params).then((res) => {
                    if (res.data.success) {
                        cb(null, res.data.success);
                    }
                })
                    .catch((err) => {

                    })
            }
        ], (err, result) => {
            dispatch(receiveSurveys(result[0],true));
            resolve(result);
        });
    });


};
